import { useQuery } from '@tanstack/react-query';
import { RATE_CONDITION_COLUMN_PREFIX } from 'constants/LaneRates';
import { getUserLaneRatesV3, getRateConditionTypes, } from 'utils/AccessorialRequestWebAPIUtils';
export function getFilterParams({ sorting, pagination, filters }) {
    const { pageIndex, pageSize } = pagination;
    let sortParams;
    if (sorting[0]) {
        sortParams = {
            sortColumn: sorting[0].id,
            sortDirection: sorting[0].desc ? 'desc' : 'asc',
        };
    }
    else {
        sortParams = {};
    }
    const query = Object.assign({ page: pageIndex + 1, per_page: pageSize }, sortParams);
    const searchParams = new URLSearchParams(query);
    const conditionTypeRegex = new RegExp(`^${RATE_CONDITION_COLUMN_PREFIX}(.)`);
    filters === null || filters === void 0 ? void 0 : filters.forEach((filter) => {
        const { id, value } = filter;
        // handle rate condition filters
        if (conditionTypeRegex.test(id)) {
            const criteria = value, type = id.replace(conditionTypeRegex, (_, char) => char.toLowerCase());
            searchParams.append('conditions', JSON.stringify({ criteria, type }));
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((item) => searchParams.append(id, item));
        }
        else {
            searchParams.append(id, value && typeof value === 'object' ? JSON.stringify(value) : value);
        }
    });
    return searchParams;
}
async function getLaneRates({ queryKey }) {
    var _a;
    const [, { sorting, pagination, filters }] = queryKey;
    const searchParams = getFilterParams({ sorting, pagination, filters });
    const res = await getUserLaneRatesV3(searchParams.toString());
    return Object.assign(Object.assign({}, (res.data || {})), { laneRates: (((_a = res.data) === null || _a === void 0 ? void 0 : _a.laneRates) || []).map((laneRate) => (Object.assign(Object.assign({}, laneRate), { id: laneRate.laneRateId }))) });
}
async function getRateConditions({ queryKey }) {
    var _a;
    const [, { customerId, laneId }] = queryKey;
    const query = {
        page: 1,
        per_page: 50,
        customerId,
        laneId,
        sortColumn: 'sequenceDate',
        sortDirection: 'asc',
    };
    const res = await getUserLaneRatesV3(new URLSearchParams(query));
    return ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.laneRates) || [];
}
export function useRateConditions({ customerId, laneId }) {
    const query = useQuery({
        queryKey: ['getRateConditions', { customerId, laneId }],
        queryFn: getRateConditions,
    });
    const { data, error, isLoading, isError, isFetching, isSuccess, status } = query;
    return { data, error, isLoading, isError, isFetching, isSuccess, status };
}
export function useLaneRates({ sorting, pagination, filters }) {
    const query = useQuery({
        queryKey: ['getLaneRates', { sorting, pagination, filters }],
        queryFn: getLaneRates,
    });
    const { data, error, isLoading, isError, isFetching, isSuccess, status, refetch, } = query;
    return {
        data,
        error,
        isLoading,
        isError,
        isFetching,
        isSuccess,
        status,
        refetch,
    };
}
export function useRateConditionTypes() {
    const query = useQuery({
        queryKey: ['getRateConditionsTypes'],
        queryFn: getRateConditionTypes,
    });
    const { data, error, isLoading, isError, isFetching, isSuccess, status } = query;
    return { data, error, isLoading, isError, isFetching, isSuccess, status };
}
